var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"notice"}},[(_vm.show)?_c('div',{staticClass:"notice"},[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }